import { trackEvent, eventNameConstants } from 'dibs-tracking';

import { pageTypeConstants } from '../../../constants/pageTypeConstants.ts';

type Args = {
    isFollowing: boolean;
    label: string;
    noninteraction?: number;
    pageType?: string | null;
};

const trackFollowButtonClick = ({ isFollowing, label, noninteraction, pageType }: Args): void => {
    const category = 'search favoriting';
    const isSellerPage =
        pageType === pageTypeConstants.DEALER || pageType === pageTypeConstants.MORE_FROM_SELLER;
    const entity = isSellerPage ? 'seller' : 'search';
    const action = `${entity} ${isFollowing ? 'added' : 'removed'}`;

    trackEvent({
        category,
        eventName: eventNameConstants.EVENT_WISHLIST,
        action,
        interaction_type: category,
        label,
        step_interaction_name: action,
        value: 0,
        noninteraction,
    });
};

export { trackFollowButtonClick };
